/**
 * Enquiry Modal Component
 *
 * @package
 */

import { __ } from '@wordpress/i18n';
import Modal from './Modal';
import EnquiryForm from './EnquiryForm';

const EnquiryModal = ( { isOpen, onClose, selectedDealer, vehicleConfigId, selectedBaseModel, selectedProducts, shareableCode, vatMode, quantities, onSuccess } ) => {
	return (
		<Modal
			isOpen={ isOpen }
			onClose={ onClose }
			title={ __( 'Send Enquiry', 'at-vehicle-configurator' ) }
			titleId="enquiry-modal-title"
			descriptionId="enquiry-modal-intro"
		>
			<p id="enquiry-modal-intro">
				{ __( 'When you send your enquiry we also receive your chosen vehicle configuration with all its options. We will go through your selections and contact you as soon as possible to help you further.', 'at-vehicle-configurator' ) }
			</p>
			<EnquiryForm
				selectedDealer={ selectedDealer }
				vehicleConfigId={ vehicleConfigId }
				selectedBaseModel={ selectedBaseModel }
				selectedProducts={ selectedProducts }
				shareableCode={ shareableCode }
				vatMode={ vatMode }
				quantities={ quantities }
				onSuccess={ () => {
					if ( onSuccess ) {
						onSuccess();
					}
					onClose();
				} }
			/>
		</Modal>
	);
};

export default EnquiryModal;
